import type { ComponentType, LazyExoticComponent, ReactNode } from 'react';

interface AppLayoutComposerProps {
  nested?: LazyExoticComponent<ComponentType<{ children: ReactNode }>>[];
  children: ReactNode;
}

/**
 * Composes the accumulated layouts of a flattened route into a nested
 * hierarchy (gpm-webapp-v2 pattern).
 *
 * `AppLayoutComposer({ nested: [DashboardLayout, ClientLayout], children: <Page /> })`
 * renders `<DashboardLayout><ClientLayout><Page /></ClientLayout></DashboardLayout>`.
 */
export function AppLayoutComposer({ nested, children }: AppLayoutComposerProps) {
  if (!nested || nested.length === 0) {
    return <>{children}</>;
  }

  return nested.reduceRight((child, Layout) => <Layout>{child}</Layout>, children);
}
